/**
 * Host classification for public creator URLs (routing, design tokens, share links).
 */

export function isBrowsablePlatformApexHost(hostname?: string): boolean {
  const host = String(
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""),
  ).toLowerCase();
  return (
    host === "browsable.ai" ||
    host === "www.browsable.ai" ||
    host === "browsable.bio" ||
    host === "www.browsable.bio" ||
    host === "searchbubble.com" ||
    host === "www.searchbubble.com"
  );
}

export function isBrowsablePlatformHostnameOrSubdomain(hostname?: string): boolean {
  const host = String(
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""),
  ).toLowerCase();
  return (
    isBrowsablePlatformApexHost(host) ||
    host.endsWith(".browsable.ai") ||
    host.endsWith(".browsable.bio")
  );
}

/** Vercel preview / production deploy hosts — keep URLs intact for feature testing. */
export function isVercelDeploymentHost(hostname?: string): boolean {
  const host = String(
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""),
  ).toLowerCase();
  return host === "vercel.app" || host.endsWith(".vercel.app");
}

export function isLocalDevHost(hostname?: string): boolean {
  const host = String(
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""),
  ).toLowerCase();
  return (
    host === "localhost" ||
    host.endsWith(".localhost") ||
    host === "127.0.0.1" ||
    host === "0.0.0.0"
  );
}

/**
 * True for hosts that run the full multi-tenant SPA (not a single-creator
 * custom domain). Skip domain_mappings spoofing / redirects on these.
 */
export function isSpaPlatformOrPreviewHost(hostname?: string): boolean {
  return (
    isLocalDevHost(hostname) ||
    isBrowsablePlatformHostnameOrSubdomain(hostname) ||
    isVercelDeploymentHost(hostname)
  );
}
